import { create } from 'zustand';
import { MetoroConfig, defaultConfig } from '../types/config';
import axios from '../utility/customAxios';

const STORAGE_KEY = 'metoro-config';

interface ConfigStore {
    config: MetoroConfig;
    isLoading: boolean;
    isInitialized: boolean;
    error: string | null;
    loadConfig: () => Promise<void>;
}

interface ConfigResponse {
    metoroConfig: MetoroConfig;
}

// Try to get config from localStorage
const getStoredConfig = (): MetoroConfig | null => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            return JSON.parse(stored);
        }
    } catch (error) {
        console.error('Failed to parse stored config:', error);
    }
    return null;
};

export const useConfigStore = create<ConfigStore>((set) => ({
    config: getStoredConfig() || defaultConfig,
    isLoading: false,
    isInitialized: false,
    error: null,
    loadConfig: async () => {
        // If we already have a stored config, use it initially
        const storedConfig = getStoredConfig();
        if (storedConfig) {
            set({ config: storedConfig, isInitialized: true });
        }

        set({ isLoading: true, error: null });
        try {
            const response = await axios.get<ConfigResponse>('/api/v1/metoro/config');
            const newConfig = response.data.metoroConfig;
            
            // Store in localStorage
            localStorage.setItem(STORAGE_KEY, JSON.stringify(newConfig));
            
            set({ 
                config: newConfig, 
                isLoading: false, 
                isInitialized: true 
            });
        } catch (error) {
            console.error('Failed to load Metoro configuration:', error);
            set({ 
                error: 'Failed to load configuration', 
                isLoading: false,
                isInitialized: true,
                // If we have stored config, keep using it on error
                config: storedConfig || defaultConfig
            });
        }
    },
})); 